import React, { ReactNode } from 'react';
import { toast } from 'react-toastify';
import NextImage from '../shared-components/NextImage/NextImage';

const grayCheckmark = 'shared/checkmark.svg';

export enum NotificationType {
  Success = 'Success',
  Error = 'Error',
  Warning = 'Warning',
  Notification = 'Notification'
}

export interface NotificationProps {
  type: NotificationType;
  message: string | ReactNode;
  id?: string;
}

const useNotification = () => {
  const showNotification = ({ message, type, id }: NotificationProps) => {
    const generalProps = {
      position: 'top-center',
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      // use timestamp as id if no id is provided
      toastId: id || `toastId-${Math.floor(Date.now() / 1000)}`
    };

    if (type === NotificationType.Error) {
      toast.error(
        message,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        { ...generalProps }
      );
    }
    if (type === NotificationType.Success) {
      toast.success(
        message,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        { ...generalProps }
      );
    }
    if (type === NotificationType.Warning) {
      toast.warning(
        message,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        { ...generalProps }
      );
    }
    if (type === NotificationType.Notification) {
      const specificProps = {
        position: 'bottom-right',
        icon: () => (
          <NextImage
            alt="check"
            src={grayCheckmark}
            layout="fixed"
            height={13}
            width={17}
          />
        )
      };
      toast(
        message,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        { ...generalProps, ...specificProps }
      );
    }
  };

  return {
    showNotification
  };
};

export default useNotification;
